import axios from 'axios';
export default axios.create({
    baseURL: 'https://yts.mx',

})
const wrapAxion = async (options, headers = {}) => {
    let defaultHeaders = {
        'Content-Type': 'application/json',
        ...headers,
    }
    return axios({
        headers: defaultHeaders,
        method: options.method,
        url: options.url,
        data: options?.data
    })
};
export const ApiWrapper = ({ types = {}, options, payload, key, messages, headers }) => async dispatch => {
    try {
        const { request, success } = types;
        const response = await wrapAxion(options, headers)
        !!request && dispatch({ type: types?.request })
        !!success && dispatch({ type: types?.success, payload: response?.data })
        return response;
    } catch (error) {
        !!types.failed && dispatch({
            type: types?.failed, payload: error
        })
        return error;
    }
}